import { inject, Injector, provideAppInitializer } from '@angular/core';

export function provideModalOpeners() {
  return provideAppInitializer(() => {
    const injector = inject(Injector);

    // can be done lazily, since the listener on newQueryParams is a ReplaySubject
    import('../shared/cards/event-card-modal/services/event-card-modal-opener.service').then(
      ({ EventCardModalOpenerService }) => injector.get(EventCardModalOpenerService).start(),
    );
    import('../shared/cards/goal-card-modal/services/goal-card-modal-opener.service').then(
      ({ GoalCardModalOpenerService }) => injector.get(GoalCardModalOpenerService).start(),
    );
  });
}
